import { Card, Table } from "antd";
import { NoShow } from "interfaces/events";

export const NoShows = ({ noShows }: { noShows: NoShow[] }) => {
  const columns = [
    {
      title: "Navn",
      dataIndex: "student",
      key: "name",
      render: (student: number, record: NoShow) => {
        return `${record.student_first_name} ${record.student_last_name}`;
      },
    },
    {
      title: "Type",
      dataIndex: "no_show_type",
      key: "no_show_type",
      render: (no_show_type: number) => {
        return no_show_type === 0 ? "No Show" : "Prikk";
      },
    },
    {
      title: "Ble utestengt?",
      dataIndex: "got_banned",
      key: "got_banned",
      render: (got_banned: boolean) => {
        return got_banned ? "Ja" : "Nei";
      },
    },
  ];

  return (
    <Card title="No Shows og Prikk" style={{ width: "100%", marginTop: "16px" }}>
      <Table
        dataSource={noShows}
        columns={columns}
        locale={{
          emptyText: "Ingen No Shows eller Prikker registrert for dette arrengementet",
        }}
      />
    </Card>
  );
};
